import { AnimatePresence, motion } from "motion/react";
import { useEffect } from "react";
import { PromptSection } from "../studio/prompt-section";
import { MyProjectsSection } from "../studio/my-projects-section";
import { FeaturedProjectsSection } from "../studio/featured-projects-section";
import { imagineStore } from "@/stores/imagine.store";
import { imagineRoutingStore } from "@/wrapper/imagine-routing.store";
import { useImagineChat } from "@/providers/imagine-chat-provider";
import { analytics, posthogClient } from "@/lib/analytics";

export function HomeView() {
  const setProject = imagineStore.use.setProject();
  const showPromptSection = imagineRoutingStore.use.showPromptSection();
  const showProjectsSection = imagineRoutingStore.use.showProjectsSection();
  const chat = useImagineChat();

  useEffect(() => {
    setProject(null);
    chat.reset();
    // Clear project context when landing on home
    analytics.setGlobalProperties({ projectId: undefined });
    posthogClient.register({ projectId: undefined });
  }, []);

  return (
    <div className="flex-1 bg-[#FFFFFF] dark:bg-[#1D1D21]">
      <AnimatePresence>
        {showPromptSection && (
          <motion.div
            key="prompt"
            initial={{ opacity: 0, y: 0 }}
            animate={{
              opacity: 1,
              y: 0,
              transition: { duration: 0.5, ease: "easeInOut" },
            }}
            exit={{
              opacity: 0,
              y: 0,
              transition: { duration: 0.25, ease: "easeInOut" },
            }}
            className="flex-1"
          >
            <PromptSection />
          </motion.div>
        )}
      </AnimatePresence>
      <AnimatePresence>
        {showProjectsSection && (
          <motion.div
            key="projects"
            initial={{ opacity: 0, y: 0 }}
            animate={{
              opacity: 1,
              y: 0,
              transition: { duration: 1, ease: "easeInOut" },
            }}
            exit={{
              opacity: 0,
              y: 30,
              transition: { duration: 0.25, ease: "easeInOut" },
            }}
            style={{ display: "block" }}
            className="p-4 sm:p-8 lg:p-12 min-w-0 overflow-x-hidden"
          >
            <MyProjectsSection />
            <FeaturedProjectsSection />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
